export default "__VITE_ASSET__fIA2QTpv__"